import React from 'react';

export default function Footer({ theme, realDay, isDark, setShowHistoryModal }) {
  return (
    <footer onClick={() => setShowHistoryModal(true)} className={`fixed bottom-0 left-0 right-0 ${theme.navBg} backdrop-blur-2xl border-t ${theme.border} px-6 py-5 z-30 cursor-pointer hover:opacity-90 transition-opacity duration-500`}>
      <div className="max-w-md mx-auto space-y-3">
        <div className={`flex justify-between items-center text-[10px] font-bold uppercase tracking-widest ${theme.muted}`}>
          <span>Timeline: <strong className={`${theme.text} ml-1`}>Día {realDay} / 60</strong></span>
          <span>Ver Histórico</span>
        </div>
        <div className={`h-1.5 w-full ${isDark ? 'bg-[#222]' : 'bg-gray-200'} rounded-full overflow-hidden`}>
          <div className={`h-full ${isDark ? 'bg-white' : 'bg-black'} transition-all duration-1000`} style={{ width: `${(realDay/60)*100}%` }}></div>
        </div>
      </div>
    </footer>
  );
}